module.exports = require("local-storage-fallback");